import React from 'react';
import moment from 'moment';
import { valueForKeyPath as v, uuid } from '../../../utils.jsx';
import ArticleContentForm from './ArticleContentForm.jsx';
import ArticlePublicationForm from './ArticlePublicationForm.jsx';
require('react-datepicker/dist/react-datepicker.css');

class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: this.props.article || {},
      articleIsLoading: false,
      section: this.props.section || {},
      sectionIsLoading: false,
    };

    this.articleDidUpdate = this.articleDidUpdate.bind(this);
    this.articleDidSave = this.articleDidSave.bind(this);
    this.articleDidPreview = this.articleDidPreview.bind(this);
    this.staticTextArticleDidSave = this.staticTextArticleDidSave.bind(this);
    this.staticTextArticleDidDelete = this.staticTextArticleDidDelete.bind(
      this,
    );
    this.sectionContentUpdate = this.sectionContentUpdate.bind(this);
    this.sectionContentDelete = this.sectionContentDelete.bind(this);
    this.sectionDidUpdate = this.sectionDidUpdate.bind(this);
  }

  componentDidMount() {
    // Nacitavanie statickeho textu
    if (this.props.staticTextCid) {
      this.setState({ articleIsLoading: true });
      let _this = this;
      _this.props
        .loadArticleForStaticText(this.props.staticTextCid)
        .then(article => {
          const aw = v(article, 'widgets', []);
          if (aw.length) {
            for (let i = 0; i < article.widgets.length; i++) {
              if (article.widgets[i].type === 'text') {
                if (typeof article.widgets[i].uuid === 'undefined') {
                  article.widgets[i].uuid = uuid();
                }
              }
            }
          }
          _this.setState({ article: article, articleIsLoading: false });
        })
        .catch(error => {
          if (error.details.code === 404) {
            _this.setState({ article: {}, articleIsLoading: false });
          } else {
            this.props.articleDidCancel();
            alert('Pri načítaní statického textu došlo k chybe');
          }
        });
    }
    // nacitanie opisneho textu rubriky
    else if (this.props.sectionId) {
      this.setState({ articleIsLoading: true });
      let _this = this;
      _this.props
        .loadSectionContent(this.props.sectionId)
        .then(article => {
          const aw = v(article, 'widgets', []);
          if (aw.length) {
            for (let i = 0; i < article.widgets.length; i++) {
              if (article.widgets[i].type === 'text') {
                if (typeof article.widgets[i].uuid === 'undefined') {
                  article.widgets[i].uuid = uuid();
                }
              }
            }
          }
          _this.setState({ article: article, articleIsLoading: false });
        })
        .catch(error => {
          alert(error);
          if (error.details.code === 404) {
            _this.setState({ article: {}, articleIsLoading: false });
          } else {
            this.props.articleDidCancel();
            alert('Pri načítaní statického textu došlo k chybe');
          }
        });
    }
    // nacitanie articlu
    else {
      // alert(this.props.articleId);
      if (this.props.articleId) {
        let _this = this;
        this.setState({ articleIsLoading: true });
        this.setState({ sectionIsLoading: true });
        this.props
          .loadArticle(this.props.articleId)
          .then(article => {
            const aw = v(article, 'widgets', []);
            if (aw.length) {
              for (let i = 0; i < article.widgets.length; i++) {
                if (article.widgets[i].type === 'text') {
                  if (typeof article.widgets[i].uuid === 'undefined') {
                    article.widgets[i].uuid = uuid();
                  }
                }
              }
            }

            this.setState({ article: article, articleIsLoading: false });

            // ak mam clanok, tak nacitam sekciu
            if (this.state.article.sectionid) {
              _this.props
                .loadSection(this.state.article.sectionid)
                .then(section => {
                  _this.setState({ section: section, sectionIsLoading: false });
                })
                .catch(error => {
                  alert(error);
                  if (error.details.code === 404) {
                    _this.setState({ section: {}, sectionIsLoading: false });
                  } else {
                    this.props.articleDidCancel();
                    alert('Pri načítaní sekcie');
                  }
                });
            } else {
              this.setState({ sectionIsLoading: false });
            }
          })
          .catch(error => {
            this.props.articleDidCancel();
            if (error.details) {
              alert(error.details.description);
            } else {
              alert(error);
            }
          });
      } else {
        // mame novy clanok
        let newarticle = this.state.article;
        newarticle.author = {
          name: this.props.defaultAuthorName,
        };
        newarticle.date = moment();
        this.setState({ article: newarticle });
      }
    }
  }

  articleDidUpdate(a) {
    this.setState({ article: a });
  }

  articleDidSave() {
    // naformatujeme datumy, musime vytvorit klon objektu
    let data = JSON.parse(JSON.stringify(this.state.article));
    if (data.date) {
      data.date = moment(this.state.article.date).format(
        'YYYY-MM-DDTHH:mm:ssZ',
      );
    } else {
      data.date = null;
    }
    // URL clanku
    if (!data.url) {
      data.url = data.urlSuggestion || null;
    }
    this.props.articleDidSave(data, this.props.articleId);
  }

  articleDidPreview() {
    // naformatujeme datumy, musime vytvorit klon objektu
    let data = JSON.parse(JSON.stringify(this.state.article));
    if (data.date) {
      data.date = moment(this.state.article.date).format(
        'YYYY-MM-DDTHH:mm:ssZ',
      );
    } else {
      data.date = null;
    }
    // URL clanku
    if (!data.url) {
      data.url = data.urlSuggestion || null;
    }
    this.props.articleDidPreview(data, this.props.articleId);
  }

  staticTextArticleDidSave() {
    this.props.onUpdateStaticTextContent(
      this.state.article,
      this.props.staticTextCid,
    );
  }

  staticTextArticleDidDelete() {
    this.props.onDeleteStaticTextContent(this.props.staticTextCid);
  }

  sectionContentUpdate() {
    this.props.onUpdateSectionContent(this.state.article, this.props.sectionId);
  }
  sectionContentDelete() {
    this.props.onDeleteSectionContent(this.props.sectionId);
  }

  sectionDidUpdate(section) {
    this.setState({ section: section });
  }

  render() {
    return (
      <div className="row" style={{ position: 'relative' }}>
        <div className="col-md-9">
          <ArticleContentForm
            contentspace_info={this.props.contentspace_info}
            article={this.state.article}
            articleDidUpdate={this.articleDidUpdate}
            widgets={this.props.widgets}
            mediaManager={this.props.mediaManager}
          />
        </div>
        <div className="col-md-3">
          <ArticlePublicationForm
            articleDidSave={this.articleDidSave}
            articleDidPreview={this.articleDidPreview}
            articleDidRemove={this.props.articleDidRemove}
            articleDidUpdate={this.articleDidUpdate}
            article={this.state.article}
            section={this.state.section}
            sections={this.props.sections}
            sectionDidUpdate={this.sectionDidUpdate}
            sectionIsLoading={this.state.sectionIsLoading}
            reloadSections={this.props.reloadSections}
            cid={this.props.staticTextCid}
            sectionId={this.props.sectionId}
            onUpdateStaticTextContent={this.staticTextArticleDidSave}
            onDeleteStaticTextContent={this.staticTextArticleDidDelete}
            onUpdateSectionContent={this.sectionContentUpdate}
            onDeleteSectionContent={this.sectionContentDelete}
            contentspace_info={this.props.contentspace_info}
            mediaManager={this.props.mediaManager}
          />
        </div>
        {this.props.articleIsSaving || this.state.articleIsLoading ? (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(255,255,255,0.7)',
            }}
          >
            <div className="loader" style={{ top: window.scrollY }} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ArticleForm;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleForm.jsx